import request from './api'
/*
 * 教师端 - 作业模块
 */

// ====== 作业 - 作业管理 ======
// 分页
export const workManagerList = (params, opts) =>
  request('/api-study/homework/pageList', params, {
    ...opts,
    method: 'post'
  });
// 发布作业模版
export const workTemplatePublish = (params, opts) =>
  request('/api-study/homework/publish', params, {
    ...opts,
    method: 'post'
  });
// 查询详情
export const workManagerGetById = (id, params, opts) =>
  request(`/api-study/homework/getHomeworkInfoById/${id}`, params, {
    ...opts
  });
// 修改
export const workManagerUpdate = (params, opts) =>
  request('/api-study/homework/updateHomeworkById', params, {
    ...opts,
    method: 'post'
  });
// 批阅列表
export const homeworkReadPageList = (params, opts) =>
  request('/api-teachingaffair/homeworkRead/pageList', params, {
    ...opts,
    method: 'post'
  });
  // 打分回显
export const getHomeworkInfoForTeacher = (id,params, opts) =>
  request(`/api-study/homework/getHomeworkInfoForTeacher/${id}`, params, {
    ...opts
  });
// 保存打分
export const homeworkRate = (params, opts) =>
  request('/api-study/homework/rate', params, {
    ...opts,
    method: 'post'
  });



// ====== 作业 - 作业库 ======
// 作业模版列表 - 全部
export const workTemplateSelect = (params, opts) =>
  request('/api-study/homeworkBase/selectList', params, {
    ...opts,
    method: 'post'
  });
// 作业模版列表 - 分页
export const workTemplateList = (params, opts) =>
  request('/api-study/homeworkBase/pageList', params, {
    ...opts,
    method: 'post'
  });
// 新增作业模版
export const workTemplateCreate = (params, opts) =>
  request('/api-study/homeworkBase/create', params, {
    ...opts,
    method: 'post'
  });
// 删除作业模版
export const workTemplateDelete = (id, params, opts) =>
  request(`/api-study/homeworkBase/delete/${id}`, params, {
    ...opts
  });
// 修改作业模版
export const workTemplateUpdate = (params, opts) =>
  request('/api-study/homeworkBase/update', params, {
    ...opts,
    method: 'post'
  });
// 查询作业模版
export const workTemplateGetById = (id, params, opts) =>
  request(`/api-study/homeworkBase/getById/${id}`, params, {
    ...opts
  });
// 删除作业管理
export const homeworkDelete = (id, params, opts) =>
  request(`/api-study/homework/delete/${id}`, params, {
    ...opts
  });
// 学生管理设置
export const homeworkGetById = (id, params, opts) =>
  request(`/api-study/homework/getById/${id}`, params, {
    ...opts
  });




// 获取学生端作业列表
export const getPageListForStudent = (params, opts) =>
    request('/api-study/homework/pageListForStudent', params, {
        ...opts,
        method: 'post'
    });
// 获取学生端作业详情
export const getHomeworkInfo = (params) =>
    request('/api-study/homework/getHomeworkInfo/'+ params.id, );
// 学生端提交保存学生答案
export const getSaveAnswer = (params, opts) =>
  request('/api-study/homeworkAnswer/saveAnswer', params, {
    ...opts,
    method: 'post'
  });



// WEBPACK FOOTER //
// ./src/api/work.js